export interface StandardTariffCodeEntity {
    id: number | null,
    versionIdentifier: {
        version?: string
    },
    tariffType: string,
    tariffCode: string,
    creationType: "StandardTariffCodeEntity",
    seq: number | null,
    parentTariffType?: string | null,
    parentTariffCode?: string | null,
    tariffCodeDesc?: string | null,
    tariffCodeDescOther?: string | null,
    includeTputInd?: "Y" | "N",
    percentage?: number | null,
    tariffSchemeId?: number | null,
    tarSchemeCode: string | null,
    activeInd: "Y" | "N",
    tariffGroupId1: string | null,
    tariffGroupId2: string | null,
    tariffGroupId3: string | null,
    tariffSeq1: number | null,
    tariffSeq2: number | null,
    tariffSeq3: number | null,
    tarNature: string | null,
    tariffNatureList: string[] | null,
    tariffCompValIdList: number[] | null,
    tempSeq: number | null,

    [key: string]: string | boolean | number | null | undefined | Object
}

export const EMPTY_STANDARD_TARIFF_CODE_ENTITY : StandardTariffCodeEntity = {
    id: null,
    versionIdentifier: {},
    tariffType: "",
    tariffCode: "",
    creationType: "StandardTariffCodeEntity",
    seq: null,
    activeInd: "Y",
    tariffGroupId1: null,
    tariffGroupId2: null,
    tariffGroupId3: null,
    tariffSeq1: null,
    tariffSeq2: null,
    tariffSeq3: null,
    tarSchemeCode: null,
    tarNature: null,
    tariffNatureList: [],
    tariffCompValIdList: [],
    percentage: 100,
    includeTputInd: 'Y',
    parentTariffType: null,
    parentTariffCode: null,
    tempSeq: null,
}